import { SharedModule } from './../../app/shared/shared.module';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ModalCreateCandidateComponent } from './create-candidate/modal-create-candidate.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ModalCreateAccountComponent } from './create-account/modal-create-account.component';
import { ModalCreateFunnelComponent } from './create-funnel/modal-create-funnel.component';
import { ModalFunnelConfirmPauseComponent } from './funnel-confirm-pause/modal-funnel-confirm-pause.component';
import { ModalFunnelSelectorComponent } from './funnel-selector/modal-funnel-selector.component';
import { ModalImportCandidatesComponent } from './import-candidates/modal-import-candidates.component';
import { ModalConfirmSubscriptionComponent } from './confirm-subscription/modal-confirm-subscription.component';
import { ModalCreateCandidateAttributeComponent } from './create-candidate-attribute/modal-create-candidate-attribute.component';
import { ModalCreateCompanyComponent } from './create-company/modal-create-company.component';
import { ModalCreateCandidateTagComponent } from './create-candidate-tag/modal-create-candidate-tag.component';
import { ModalInviteTeamMemberComponent } from './invite-team-member/modal-invite-team-member.component';
import { ModalConfirmDeleteApplicationsComponent } from './confirm-delete-applications/modal-confirm-delete-applications.component';
import { ModalConfirmDeleteAccountComponent } from './confirm-delete-account/modal-confirm-delete-account.component';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ModalCreateLabelComponent } from './create-label/modal-create-label.component';
import { ModalCreateGroupComponent } from './create-group/modal-create-group.component';
import { ModalConfirmComponent } from './confirm-delete-candidates/modal-confirm.component';
import { ModalConfirmResumeComponent } from './confirm-resume/modal-confirm-resume.component';
import { ModalEmailVerificationSelectorComponent } from './email-verification-selector/email-verification-selector.component';
import { ImportCandidatesGmailComponent } from './import-candidates/import-candidates-gmail/import-candidates-gmail.component';
import { NgxFileDropModule } from 'ngx-file-drop';
import { ImportCandidatesFormComponent } from './import-candidates/import-candidates-form/import-candidates-form.component';
import { ModalConfirmLeaveComponent } from './confirm-leave/modal-confirm-leave.component';
import { ModalNotificationComponent } from './notification/modal-notification.component';
import { ModalUpdateCardComponent } from './update-card/modal-update-card.component';
import { ModalCandidateSelectorComponent } from './candidate-selector/modal-candidate-selector.component';
import { ModalConfirmUnsubscribeComponent } from './confirm-unsubscribe/modal-confirm-unsubscribe.component';
import { ModalTagsSelectorComponent } from './tags-selector/modal-tags-selector.component';
import { ModalCreateCustomInboxComponent } from './custom-inbox-settings/modal-create-custom-inbox.component';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { ModalModifySubscriptionComponent } from './modify-subscription/modify-subscription.component';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ModalReAuthenticateInboxComponent } from './re-authenticate-inbox/modal-re-authenticate-inbox.component';
import { ImportCandidatesCsvComponent } from './import-candidates/import-candidate-csv/import-candidates-csv.component';
import { ModalAddFunnelStepComponent } from './add-funnel-step/modal-add-funnel-step.component';

@NgModule({
  declarations: [
    ModalConfirmLeaveComponent,
    ModalModifySubscriptionComponent,
    ModalUpdateCardComponent,
    ModalCreateCandidateComponent,
    ModalCreateAccountComponent,
    ModalCreateFunnelComponent,
    ModalFunnelConfirmPauseComponent,
    ModalFunnelSelectorComponent,
    ModalCandidateSelectorComponent,
    ModalImportCandidatesComponent,
    ModalReAuthenticateInboxComponent,
    ModalCreateCustomInboxComponent,
    ModalConfirmSubscriptionComponent,
    ModalConfirmUnsubscribeComponent,
    ModalTagsSelectorComponent,
    ModalCreateCandidateAttributeComponent,
    ModalCreateCompanyComponent,
    ModalCreateCandidateTagComponent,
    ModalCreateLabelComponent,
    ModalConfirmComponent,
    ModalConfirmResumeComponent,
    ModalNotificationComponent,
    ModalInviteTeamMemberComponent,
    ModalConfirmDeleteApplicationsComponent,
    ModalConfirmDeleteAccountComponent,
    ModalCreateGroupComponent,
    ModalEmailVerificationSelectorComponent,
    ImportCandidatesGmailComponent,
    ImportCandidatesCsvComponent,
    ImportCandidatesFormComponent,
    ModalAddFunnelStepComponent,
  ],
  exports: [
    ModalNotificationComponent,
    ModalConfirmLeaveComponent,
    ModalModifySubscriptionComponent,
    ModalUpdateCardComponent,
    ModalCreateCandidateComponent,
    ModalCreateAccountComponent,
    ModalCreateFunnelComponent,
    ModalFunnelConfirmPauseComponent,
    ModalFunnelSelectorComponent,
    ModalCandidateSelectorComponent,
    ModalImportCandidatesComponent,
    ModalReAuthenticateInboxComponent,
    ModalCreateCustomInboxComponent,
    ModalConfirmSubscriptionComponent,
    ModalConfirmUnsubscribeComponent,
    ModalTagsSelectorComponent,
    ModalCreateCandidateAttributeComponent,
    ModalCreateCompanyComponent,
    ModalCreateCandidateTagComponent,
    ModalCreateLabelComponent,
    ModalConfirmComponent,
    ModalConfirmResumeComponent,
    ModalInviteTeamMemberComponent,
    ModalConfirmDeleteApplicationsComponent,
    ModalConfirmDeleteAccountComponent,
    ModalCreateGroupComponent,
    ModalEmailVerificationSelectorComponent,
    ModalAddFunnelStepComponent,
  ],
  entryComponents: [
    ModalNotificationComponent,
    ModalConfirmLeaveComponent,
    ModalModifySubscriptionComponent,
    ModalUpdateCardComponent,
    ModalCreateCandidateComponent,
    ModalCreateAccountComponent,
    ModalCreateFunnelComponent,
    ModalFunnelConfirmPauseComponent,
    ModalFunnelSelectorComponent,
    ModalCandidateSelectorComponent,
    ModalImportCandidatesComponent,
    ModalReAuthenticateInboxComponent,
    ModalCreateCustomInboxComponent,
    ModalConfirmSubscriptionComponent,
    ModalConfirmUnsubscribeComponent,
    ModalTagsSelectorComponent,
    ModalCreateCandidateAttributeComponent,
    ModalCreateCompanyComponent,
    ModalCreateCandidateTagComponent,
    ModalCreateLabelComponent,
    ModalConfirmComponent,
    ModalConfirmResumeComponent,
    ModalInviteTeamMemberComponent,
    ModalConfirmDeleteApplicationsComponent,
    ModalConfirmDeleteAccountComponent,
    ModalCreateGroupComponent,
    ModalEmailVerificationSelectorComponent,
    ModalAddFunnelStepComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    ReactiveFormsModule,
    NgxFileDropModule,
    TooltipModule.forRoot(),
    PaginationModule.forRoot(),
    TimepickerModule.forRoot(),
    BsDatepickerModule.forRoot(),
  ],
})
export class ModalsModule {
  constructor() {
    console.log('>>> ModalsModule loaded');
  }
}

console.log('modals.module.ts');
